import { Box, Divider, Fade, Grid, Typography } from "@material-ui/core"
import { useNotificacoes } from "components/notificacoes"
import { VendaCompletaModel } from "models/api/venda/venda-completa-model"
import React, { useCallback, useEffect, useMemo, useState } from "react"
import { toDateString } from "utils/to-date"
import { useStyles } from "./historico-pedido-content-styles"
import { CardHistoricoPedidoProduto } from "components/cards/card-historico-pedido-produto/card-historico-pedido-produto"
import { HistoricoPedidoValores } from "./components/historico-pedido-valores/historico-pedido-valores"
import { useEmpresaAtual } from "services/hooks/empresa"
import { useMasterApi } from "modulos/cardapio/containers/cardapio/hooks"
import { useGetMovimentoById } from "api/movimentacao/get-movimento-by-id"
import { CircularLoading } from "components/utils/circular-loading"
import { EnumConfigEmpresa } from "models/enums/enum-config-empresa"

export type HistoricoPedidoContentProps = {
    pedidoId: string
}

export const HistoricoPedidoContent = ({ pedidoId }: HistoricoPedidoContentProps) => {
    const { showErrorMessage } = useNotificacoes()
    const { getEmpresaAtual, getConfigByCod } = useEmpresaAtual()
    const empresaId = getEmpresaAtual()?.id ?? '';
    const { dados: apiMasterDados } = useMasterApi(empresaId);
    const configDelivery = useMemo(() => apiMasterDados.data?.configuracoesDelivery, [apiMasterDados]);
    const prodDelivery = configDelivery?.produtoEntrega ?? undefined;
    const prodServico = getConfigByCod(EnumConfigEmpresa.ProdutoServico)
    const { getMovimentoById, carregando } = useGetMovimentoById()

    const [venda, setVenda] = useState<VendaCompletaModel>()

    const classes = useStyles()

    const getPedidoById = useCallback(async () => {
        try {
            const res = await getMovimentoById(empresaId ?? '', pedidoId)
            if (res.erro) throw res.erro
            setVenda(res.resultado?.data)
        } catch (err: any) {
            showErrorMessage(err.message)
        }
    }, [empresaId, getMovimentoById, pedidoId, showErrorMessage])

    const prodEntrega = venda?.infMov.prod.find((prod) => prod.produtoId === prodDelivery?.id)
    const prodServicoItem = venda?.infMov.prod.find((prod) => prod.produtoId === prodServico?.valor)

    const vSubtotal = (venda?.infMov.total.vProd || 0) - (prodEntrega?.vUnCom || 0) - (prodServicoItem?.vUnCom || 0)

    useEffect(() => {
        getPedidoById()
    }, [getPedidoById])

    if (carregando) {
        return (
            <Fade in>
                <Box position="relative" height="calc(100vh - 60px)" width="100%">
                    <CircularLoading tipo="FULLSIZED" titulo="Carregando..." />
                </Box>
            </Fade>
        )
    }

    const produtos = venda?.infMov.prod.filter((prod) => prod.produtoId !== prodDelivery?.id && prod.produtoId !== prodServico?.valor) || []

    return (
        <Fade in>
            <Box p={2}>
                <Box mt={-1}>
                    <Typography variant="body2" color="textSecondary">
                        Feito em: {toDateString(venda?.infMov.dhEmi, 'DD/MM/YYYY HH:mm')}
                    </Typography>
                </Box>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="h4" className={classes.title}>
                            N° Nota: {venda?.infMov.nnf}
                        </Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        <HistoricoPedidoValores
                            vTotal={venda?.infMov.total.vProd || 0}
                            vTaxaEntrega={prodEntrega?.vProd}
                            vTaxaServico={prodServicoItem?.vProd}
                            vSubtotal={vSubtotal}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body1">
                            Itens
                        </Typography>
                        <Divider />
                    </Grid>
                    {produtos.map(prod => {
                        return (
                            <Grid item xs={12}>
                                <CardHistoricoPedidoProduto key={prod.id} model={prod} />
                            </Grid>
                        )
                    })}
                </Grid>
            </Box>
        </Fade>
    )
}